import React from "react";
import { AppContainer, Header, Logo, MenuButton } from "./styles";

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <AppContainer>
      {/* <Particles />
      <FloatingOrbs /> */}

      <Header>
        <Logo>
          <img
            src="/images/assets/shield_logo.png"
            alt="Shield Logo"
            style={{ height: "50px" }}
          />
        </Logo>
        <MenuButton>☰</MenuButton>
      </Header>

      {children}
    </AppContainer>
  );
};
